// src/evaluationDoneStatSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   empsArr : [] ,
};

const doneEvaluationStatSlice = createSlice({
  name: 'tempDoneEvaluationStat',
  initialState,
  reducers: {
    setData(state, action) {
      state.empsArr = action.payload;
    },
    clearData(state) {
      state.empsArr = [];
    }
  }
});

export const { setData, clearData } = doneEvaluationStatSlice.actions;
export default doneEvaluationStatSlice.reducer;
